import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const ColumnHost = ({ hostName, brand }) => {
  return (
    <Box className={styles['column__host-container']}>
      <TextRegular className={styles['column__host-name']}>{hostName}</TextRegular>
      <TextRegular className={styles['column__host-brand']}>{brand}</TextRegular>
    </Box>
  );
};

export default ColumnHost;
